import {
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";
import { CiFilter } from "react-icons/ci";
import { MdOutlineSimCardDownload } from "react-icons/md";
import { useSelector } from "react-redux";
import APopover from "../../common/a-popover";
import AButton from "../../common/form-fields-mui/AButton";
import AInput from "../../common/formFeilds/customInput/AInput";
import AllocateStudentFilterForm from "./AllocateStudentFilterForm";
import SelectSearchInputParam from "../studentSerach/SelectSearchInputParam";
import ATextAreaV2 from "../../../../../components/ATextAreaV2/ATextAreaV2";
import { getInputParamRegex, getUpdatedInputParamKey, getUpdatedUserInput, multiValuesSearchPasteHandler } from "../constant/student-search";

const highlightedStyle = {
  border: "1px solid #00B0F5",
  color: "#00B0F5",
  minWidth: "80px",
};
// const normalStyle = {
//   border: "1px solid #E9ECEF",
// };

const AllocateStudentSearchFilter = ({
  data,
  handleEligibleOnlyFilter,
  batchDetails,
  inputHandler,
  applyFilterHandler,
  removeFilter,
  form,
  filterCount,
  eligibleOnly,
  clearNameFilterHandler,
  applyNameFilterHandler,
  downloadCsvHandler,
}) => {
  const downloadCsvLoader = useSelector(
    (state) => state.allocateStudents.downloadCsvLoader
  );
  const rowCount = useSelector(
    (state) => state?.allocateStudents?.studentListRowCount
  );

  // const onKeyDown = (e) => {
  //   if (e.key === "Enter" || e.keyCode === 13) {
  //     applyNameFilterHandler({ [searchInputParam]: userInput });
  //   }
  // };

  const searchHandler = (userInput) => {
    const updatedInputParam = getUpdatedInputParamKey(searchInputParam);
    const updatedUserInput = getUpdatedUserInput(userInput, searchInputParam);
    applyNameFilterHandler({ [updatedInputParam]: updatedUserInput });
  }

  const [searchInputParam, setSearchInputParam] = useState("psid");
  const [userInput, setUserInput] = useState("");
  let searchParamTitleMap = {
    psid: "PSIDs",
    studentName: "student name",
    applicationId: "application IDs",
  };



  return (
    <div className="d-flex align-items-start">
      <div className="d-flex flex-column postition-relative">
        {/* <div>
          <AInput
            placeholder={`Search by ${searchParamTitleMap[searchInputParam]}`}
            // style={{ flex: 1, marginRight: '10px', ...normalStyle }}
            value={userInput}
            handler={(value) => setUserInput(value)}
            onKeyDown={(e) => onKeyDown(e)}
            crossIcon={true}
            crossHandler={() => {
              setUserInput("");
              clearNameFilterHandler();
            }}
          />
        </div> */}
        <ATextAreaV2
        style={{width : "260px"}}
        placeholder={`Search by ${searchParamTitleMap[searchInputParam]}`}
        key={searchInputParam}
        regex={getInputParamRegex(searchInputParam)}
        searchHandler={searchHandler}
        crossHandler={clearNameFilterHandler}
        value={userInput}
        onInputChange={val => setUserInput(val)}
        onPaste={(e) => multiValuesSearchPasteHandler(e, (sanitizedText) => setUserInput(prev => prev + sanitizedText))}
        />
        <div className="mt-4">
        <SelectSearchInputParam
          searchInputParam={searchInputParam}
          setSearchInputParam={setSearchInputParam}
        />
        </div>
      </div>
      <FormControlLabel
        style={{ height: "20px", margin: ".2rem" }}
        sx={{
          "& .MuiTypography-root": {
            fontSize: "14px",
            height: "20px",
          },
          "& .MuiButtonBase-root": {
            padding: "0 2px",
          },
        }}
        control={<Checkbox size="small" checked={eligibleOnly} />}
        label="Show only eligible students for allocation"
        onChange={(e) => {
          handleEligibleOnlyFilter(e.target.checked);
        }}
      />
      <APopover
        buttonComponent={(onClick, styles) => (
          <AButton
            onClick={onClick}
            updatedStyle={filterCount > 0 ? highlightedStyle : styles}
          >
            <CiFilter />
            Filter {filterCount > 0 && <>( {filterCount} )</>}
          </AButton>
        )}
        menuComponent={(onClose) => (
          <AllocateStudentFilterForm
            batchType={batchDetails.batchType}
            inputHandler={inputHandler}
            applyFilterHandler={() => {
              applyFilterHandler();
              onClose();
            }}
            removeFilter={removeFilter}
            form={form}
          />
        )}
        width={"323px"}
        maxHeight={"calc(100% - 200px)"}
        highlightedStyle={highlightedStyle}
        // normalStyle={normalStyle}
      />
      {/* <AButton onClick={downloadCsvHandler} disabled={downloadCsvLoader} >
        {downloadCsvLoader ? <CircularProgress color="inherit" size={"12px"} /> : <MdOutlineSimCardDownload />}
        Download CSV
      </AButton> */}
      {rowCount > 2000 ? (
        <Tooltip title="Number of students exceed the download limit of 2000 records. Use filters including business area(s) to narrow down the results to download">
          <AButton>
            <MdOutlineSimCardDownload />
            Download CSV
          </AButton>
        </Tooltip>
      ) : (
        <AButton onClick={downloadCsvHandler} disabled={downloadCsvLoader}>
          {downloadCsvLoader ? (
            <CircularProgress color="inherit" size={"12px"} />
          ) : (
            <MdOutlineSimCardDownload />
          )}
          Download CSV
        </AButton>
      )}
    </div>
  );
};

export default AllocateStudentSearchFilter;
